import React, { useEffect, useState } from "react";
import "./Product_Info.css";
import { Form } from "react-bootstrap";
import {
  faAngleDown,
  faAngleRight,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Increment_decrement_btn_holder from "../../common-components/common-btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useForm } from "react-hook-form";
import Gray_Outline_Button from "../../common-components/common-btn/gray_outline_btn/Gray_Outline_Button";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartLens,
  deleteSingleCart,
  getAllCart,
  attachPrescriptionToCart,
  updateCartQuantity,
} from "../../../features/cart/cartSlice";
import { getAllLensType } from "../../../features/master/masterSlice";
import {
  CouponApplyed,
  OrderCalculation,
} from "../../../features/order/orderSlice";
import { Category } from "../../../utils/common";
import useIsMobile from "./useIsMobile"; // 👈 new hook
import Success_Modal from "../../common-components/common-modals/success_modal/Success_Modal";
import View_All_Coupon_Code from "../../common-components/common-modals/view_All_Coupon_Code/View_All_Coupon_Code";
import Red_Outline_Btn from "../../common-components/common-btn/red_outline_btn/Red_Outline_Btn";
import Lens_Details_Modal from "../../common-components/common-modals/lens_details_modal/Lens_Details_Modal";
import FuseButton from "../../common-components/common-btn/fuse_button/FuseButton";

/*
 * Fixed lens type IDs for the three "Add Your Lenses" buttons.

 */
const LENS_TYPE_BUTTONS = [
  {
    id: 14,
    label: "Progressive Lens",
    tooltip:
      'Lenses that correct multiple fields of vision (near, intermediate, and distance). Requires a prescription with "add power" (ADD).',
  },
  {
    id: 15,
    label: "Single Vision",
    tooltip: "Corrects one field of vision (near or distance).",
  },
  {
    id: 16,
    label: "Bifocal",
    tooltip:
      'Lenses with two zones: distance vision on top and a segment for near vision at the bottom. Requires a prescription with "add power" (ADD).',
  },
];

// Contact lens category id — the quantity stepper only shows for this category
const CONTACT_LENS_CATEGORY_ID = 3;
const MIN_QTY = 1;
const MAX_QTY = 99;

// Remove button with a 4s undo window. The API call only fires when the fuse burns out.
// Defined at module level on purpose: if it lived inside Product_Info it would remount
// on every re-render and the countdown would restart/cancel.
const RemoveFuse = ({ onRemove }) => (
  <FuseButton
    label="Remove"
    undoLabel="Undo"
    doneLabel="Removed"
    icon={<FontAwesomeIcon icon={faCircleXmark} />}
    color="#f44336"
    background="#fdecea"
    fuseColor="#f44336"
    size="sm"
    radius={18}
    undoWindow={4000}
    fuse="outline"
    commitOn="fuseEnd"
    onCommit={onRemove}
  />
);

// Returns the rounded % off between mrp and price, or 0 if not applicable
const getDiscountPercent = (mrp, price) => {
  const mrpNum = Number(mrp || 0);
  const priceNum = Number(price || 0);
  if (mrpNum <= 0 || priceNum <= 0 || mrpNum <= priceNum) return 0;
  return Math.round(((mrpNum - priceNum) / mrpNum) * 100);
};

const Product_Info = ({
  carts,
  setCouponData,
  CouponData,
  setSelectedIds,
  selectedIds,
  orderSumary,
}) => {
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [openStates, setOpenStates] = useState({});

  const [modalShow, setModalShow] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const isSignIn = useSelector((state) => state.auth.is_signin);

  // ---------------- Add Your Lenses ----------------
  const lensType = useSelector((state) => state.master.lens_type);
  const [lensTarget, setLensTarget] = useState(null); // cart item being edited
  const [lensTypeId, setLensTypeId] = useState(null);
  const [showLensDetails, setShowLensDetails] = useState(false);

  // Tooltip shown when hovering a lens button: { text, left, top, below }
  const [tooltip, setTooltip] = useState(null);

  // Still fetched so we can show the backend name for each ID (falls back to our label)
  useEffect(() => {
    if (!lensType?.length) dispatch(getAllLensType());
    // eslint-disable-next-line
  }, []);

  // Look up the backend name for a fixed ID, fallback to the local label
  const getLensTypeName = (id) => {
    const fromApi = lensType?.find((lt) => Number(lt?.id) === Number(id))?.name;
    const fromConfig = LENS_TYPE_BUTTONS.find((b) => b.id === Number(id))?.label;
    return fromApi || fromConfig || "";
  };

  // Same rule as isFrameCategory on the product page
  const canAddLens = (item) => {
    const cat = Number(item?.Product?.p_category_id);
    const isFrame =
      cat !== Number(Category.ContactLens) &&
      cat !== Number(Category.Lenses) &&
      cat !== Number(Category.Accessories);
    return isFrame && !item?.Prescription?.Lense;
  };

  const openLensFlow = (item, typeId) => {
    setLensTarget(item);
    setLensTypeId(typeId);
    setShowLensDetails(true);
  };

  const handleCartLensAdded = async (typeId, lensInfo) => {
    const prescriptionId = lensInfo?.prescriptionId;
    if (!typeId || !prescriptionId || !lensTarget) return;

    try {
      const res = await dispatch(
        attachPrescriptionToCart({
          id: lensTarget?.id,
          prescription_id: prescriptionId,
        }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setCouponData();
        setValue("code", "");
        dispatch(getAllCart(isSignIn));
      } else {
        console.log("Error:", res.payload || "Could not add lens");
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLensTarget(null);
    }
  };

  const showLensTooltip = (e, text) => {
    const r = e.currentTarget.getBoundingClientRect();
    const maxW = Math.min(260, window.innerWidth - 16);
    setTooltip({
      text,
      maxW,
      left: Math.max(8, Math.min(r.left, window.innerWidth - maxW - 8)),
      // above the button if there is room, otherwise below it
      top: r.top > 110 ? r.top - 10 : r.bottom + 10,
      below: r.top <= 110,
    });
  };

  const hideLensTooltip = () => setTooltip(null);

  // fixed position would be stale after scrolling, so just hide it
  useEffect(() => {
    if (!tooltip) return;
    window.addEventListener("scroll", hideLensTooltip, true);
    return () => window.removeEventListener("scroll", hideLensTooltip, true);
  }, [tooltip]);

  // Reusable block for desktop + mobile
  const renderAddLensButtons = (item) => (
    <div className="cart-add-lens">
      <h6 className="cart-add-lens-heading">Add Your Lenses</h6>
      <div className="cart-add-lens-btns">
        {LENS_TYPE_BUTTONS.map((lt) => (
          <button
            type="button"
            key={lt.id}
            className="cart-add-lens-btn"
            onMouseEnter={(e) => showLensTooltip(e, lt.tooltip)}
            onMouseLeave={hideLensTooltip}
            onFocus={(e) => showLensTooltip(e, lt.tooltip)}
            onBlur={hideLensTooltip}
            onClick={() => {
              hideLensTooltip();
              openLensFlow(item, lt.id); // 14 / 15 / 16
            }}
          >
            {getLensTypeName(lt.id)}
          </button>
        ))}
      </div>
    </div>
  );
  // -------------------------------------------------

  // ---------------- Quantity (contact lenses only) ----------------
  const [qtyBusyId, setQtyBusyId] = useState(null); // cart id being updated

  const isContactLens = (item) =>
    Number(item?.Product?.p_category_id) === CONTACT_LENS_CATEGORY_ID;

  const getQty = (item) =>
    Math.min(
      Math.max(parseInt(item?.quantity, 10) || MIN_QTY, MIN_QTY),
      MAX_QTY,
    );

  const changeQuantity = async (item, nextQty) => {
    const next = Math.min(Math.max(nextQty, MIN_QTY), MAX_QTY);
    if (next === getQty(item) || qtyBusyId) return;

    setQtyBusyId(item?.id);
    try {
      const res = await dispatch(
        updateCartQuantity({ id: item?.id, quantity: next }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        // quantity changed -> any applied coupon must be re-checked
        setCouponData();
        setValue("code", "");
        await dispatch(getAllCart(isSignIn));
      } else {
        console.log("Error:", res.payload || "Could not update quantity");
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setQtyBusyId(null);
    }
  };

  // Same stepper for desktop + mobile; renders nothing for other categories
  const renderQtyStepper = (item) => {
    if (!isContactLens(item)) return null;

    const qtyVal = getQty(item);
    const busy = qtyBusyId === item?.id;

    return (
      <div className="cart-qty-stepper" aria-busy={busy}>
        <button
          type="button"
          className="cart-qty-btn"
          disabled={busy || qtyVal <= MIN_QTY}
          onClick={() => changeQuantity(item, qtyVal - 1)}
          aria-label="Decrease quantity"
        >
          −
        </button>

        <span className="cart-qty-value">{qtyVal}</span>

        <button
          type="button"
          className="cart-qty-btn"
          disabled={busy || qtyVal >= MAX_QTY}
          onClick={() => changeQuantity(item, qtyVal + 1)}
          aria-label="Increase quantity"
        >
          +
        </button>
      </div>
    );
  };
  // ----------------------------------------------------------------

  const toggleRow = (id) => {
    setOpenStates((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const DeleteCartProduct = async (id, product_id, variant_id) => {
    try {
      const data = { id, isSignin: isSignIn, product_id, variant_id };
      const res = await dispatch(deleteSingleCart(data));
      if (res.meta?.requestStatus === "fulfilled") {
        setCouponData();
        setValue("code", "");
        dispatch(getAllCart(isSignIn));
      } else {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const DeleteCartLeans = async (id, product_id, variant_id) => {
    try {
      const data = { id, isSignin: isSignIn, product_id, variant_id };
      const res = await dispatch(deleteCartLens(data));
      if (res.meta?.requestStatus === "fulfilled") {
        setCouponData();
        setValue("code", "");
        dispatch(getAllCart(isSignIn));
      } else {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleCouponReset = () => {
    setCouponData();
    setValue("code", "");
  };

  const onSubmit = async (data) => {
    // data.amount = orderSumary?.order_summary?.total_amount;
    data.amount = orderSumary?.order_summary?.total_mrp;
    const res = await dispatch(CouponApplyed(data));
    if (res?.payload?.data) {
      setCouponData(res?.payload?.data);
      setShowModal(true);
    }
    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload?.errors,
      });
    }
  };

  const isMobile = useIsMobile();

  const allIds = carts?.data?.data?.map((item) => item?.id) || [];

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
    setCouponData();
    setValue("code", "");
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(allIds);
      setCouponData();
      setValue("code", "");
    } else {
      setSelectedIds([]);
      setCouponData();
      setValue("code", "");
    }

    // handleCouponReset()
  };
  const [Error, setErrors] = useState("");

  return (
    <section className="Product_Info">
      <div className="container">
        {isMobile ? (
          <div className="mobile_view_table_holder">
            <div className="select_all_div">
              <Form.Check
                type="checkbox"
                checked={
                  selectedIds.length === allIds.length && allIds.length > 0
                }
                onChange={handleSelectAll}
              />
            </div>

            {carts?.data?.data?.map((item, index) => {
              const isOpen = openStates[item.id] || false;

              return (
                <div
                  className="mobile_addon_card_section_holder"
                  key={item?.id ?? index}
                >
                  <div className="mobile_product_card">
                    <div className="row">
                      <div className="col-5">
                        <div className="select_div">
                          <Form.Check
                            type="checkbox"
                            checked={selectedIds.includes(item?.id)}
                            onChange={() => handleCheckboxChange(item?.id)}
                          />
                        </div>
                        <div className="img_holder">
                          <img
                            src={
                              process.env.REACT_APP_IMAGE_URL +
                              item?.Product?.image
                            }
                            alt={item?.Product?.name}
                            className="prod_img"
                          />
                        </div>
                      </div>
                      <div className="col-7 ps-0">
                        <div className="descn_holder common_table ">
                          <div className="all_btns_holder">
                            <div className="Quantity_tr_holder">
                              {Error}
                              <RemoveFuse
                                onRemove={() =>
                                  DeleteCartProduct(item?.id, item?.product_id)
                                }
                              />
                            </div>
                          </div>
                          <div className="product_details">
                            <div className="bold_text product_title">
                              {item?.Product?.name}
                            </div>

                            <div className="price_qty_wrap">
                              <div className="price_cell">
                                <span className="bold_text current_price">
                                  ₹{item?.Product?.price}
                                </span>
                                {getDiscountPercent(
                                  item?.Product?.mrp,
                                  item?.Product?.price,
                                ) > 0 && (
                                  <>
                                    <span className="mrp_price">
                                      ₹{item?.Product?.mrp}
                                    </span>
                                    <span className="discount_badge">
                                      {getDiscountPercent(
                                        item?.Product?.mrp,
                                        item?.Product?.price,
                                      )}
                                      % off
                                    </span>
                                  </>
                                )}
                              </div>

                              {/* Quantity stepper — contact lenses only */}
                              {renderQtyStepper(item)}
                            </div>

                            <div className="product_details mb-3">
                              <div className="bold_text">Product Details</div>
                              <p className="normal_text">
                                <b>Frame Type –</b>{" "}
                                {item?.Product?.Frame_Type?.name || "NA"}
                              </p>
                              <p className="normal_text">
                                <b>Size –</b> {item?.Product?.size || "NA"}
                              </p>
                              <p className="normal_text">
                                <b>Material –</b>{" "}
                                {item?.Product?.Material?.name || "NA"}
                              </p>
                              <p className="normal_text">
                                <b>Colour – </b>
                                {item?.Product?.Colour?.name || "NA"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ---------- Mobile: Add Your Lenses ---------- */}
                  {canAddLens(item) && (
                    <div className="addon_section_holder">
                      {renderAddLensButtons(item)}
                    </div>
                  )}

                  {item?.Prescription?.Lense && (
                    <div className="addon_section_holder">
                      <div className="mobile_product_card">
                        <div className="row">
                          <div className="col-5">
                            <div className="img_holder">
                              <img
                                src={"/assets/images/lanse/lense_img_1.png"}
                                alt="lense"
                                className="product_img"
                              />
                            </div>
                          </div>
                          <div className="col-7 ps-0">
                            <div className="mobile_remove_fuse">
                              <RemoveFuse
                                onRemove={() =>
                                  DeleteCartLeans(
                                    item?.Prescription?.id,
                                    item?.product_id,
                                  )
                                }
                              />
                            </div>
                            <div className="descn_holder common_table ">
                              <div className="product_details">
                                <div className="bold_text">
                                  {item?.Product?.name}
                                </div>

                                <div className="price_cell">
                                  <span className="bold_text current_price">
                                    ₹{item?.Prescription?.Lense?.price ?? "NA"}
                                  </span>
                                  {getDiscountPercent(
                                    item?.Prescription?.Lense?.mrp,
                                    item?.Prescription?.Lense?.price,
                                  ) > 0 && (
                                    <>
                                      <span className="mrp_price">
                                        ₹{item?.Prescription?.Lense?.mrp}
                                      </span>
                                      <span className="discount_badge">
                                        {getDiscountPercent(
                                          item?.Prescription?.Lense?.mrp,
                                          item?.Prescription?.Lense?.price,
                                        )}
                                        % off
                                      </span>
                                    </>
                                  )}
                                </div>

                                <div className="product_details mb-3">
                                  <div className="bold_text">Lens Details</div>
                                  <p className="normal_text">
                                    Lens Type –{" "}
                                    {item?.Prescription?.Lense?.LensType?.name}
                                  </p>
                                  <p className="normal_text">
                                    Brand –{" "}
                                    {item?.Prescription?.Lense?.Brand?.name ||
                                      "NA"}
                                  </p>
                                  <p className="normal_text">
                                    Material –{" "}
                                    {item?.Prescription?.Lense?.Material
                                      ?.name || "NA"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {item?.Prescription?.Addon && (
                        <div className="mobile_product_card">
                          <div className="row">
                            <div className="col-5">
                              <div className="img_holder">
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_URL +
                                    item?.Prescription?.Addon?.image
                                  }
                                  alt="lense"
                                  className="product_img"
                                />
                              </div>
                            </div>
                            <div className="col-7 ps-0">
                              <div className="descn_holder common_table ">
                                <div className="product_details">
                                  <div className="bold_text">
                                    {item?.Product?.name}
                                  </div>

                                  <div className="price_cell">
                                    <span className="bold_text current_price">
                                      ₹
                                      {item?.Prescription?.Addon?.price ?? "NA"}
                                    </span>
                                    {getDiscountPercent(
                                      item?.Prescription?.Addon?.mrp,
                                      item?.Prescription?.Addon?.price,
                                    ) > 0 && (
                                      <>
                                        <span className="mrp_price">
                                          ₹{item?.Prescription?.Addon?.mrp}
                                        </span>
                                        <span className="discount_badge">
                                          {getDiscountPercent(
                                            item?.Prescription?.Addon?.mrp,
                                            item?.Prescription?.Addon?.price,
                                          )}
                                          % off
                                        </span>
                                      </>
                                    )}
                                  </div>

                                  <div className="product_details mb-3">
                                    <div className="bold_text">
                                      Add Ons Details
                                    </div>
                                    <p className="normal_text">
                                      Name –{" "}
                                      {item?.Prescription?.Addon?.name || "NA"}
                                    </p>
                                    <p className="normal_text">
                                      Price –{" "}
                                      {item?.Prescription?.Addon?.price || "NA"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            <Form>
              <div className="footer_div mt-3">
                <h6 style={{ fontSize: "11px", marginBottom: "11px" }}>
                  Best Coupons
                </h6>

                <p
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "11px",
                    marginBottom: "11px",
                  }}
                  onClick={() => setModalShow(true)}
                >
                  View All Coupon <FontAwesomeIcon icon={faAngleRight} />
                </p>
              </div>

              <div className="footer_div">
                <Form.Group className="input_group">
                  <Form.Control
                    type="text"
                    placeholder="Enter your coupon code"
                    {...register("code", { required: "Code is required" })}
                  />
                  {errors?.code && (
                    <sup className="text-danger">{errors?.code?.message}</sup>
                  )}
                </Form.Group>
                <div className="btn_holder">
                  <Gray_Outline_Button
                    type="button"
                    btnText={"Apply"}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </Form>
          </div>
        ) : (
          <div className="desktop_view">
            <div className="common_table_container theme_bg">
              <div className="table-responsive">
                <table className="common_table table">
                  <thead>
                    <tr>
                      <th>
                        <Form.Check
                          type="checkbox"
                          checked={
                            selectedIds.length === allIds.length &&
                            allIds.length > 0
                          }
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th> Product Info</th>
                      <th>Price</th>
                      <th>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    {carts?.data?.data.map((item, idx) => {
                      const hasLens = !!item?.Prescription?.Lense;
                      const hasAddon = hasLens && !!item?.Prescription?.Addon;
                      const showAddLens = canAddLens(item);

                      return (
                        <React.Fragment key={item?.id ?? idx}>
                          {/* ---------- Product row ---------- */}
                          <tr
                            className={hasLens || showAddLens ? "has_addon" : ""}
                          >
                            <td>
                              <Form.Check
                                type="checkbox"
                                checked={selectedIds.includes(item?.id)}
                                onChange={() => handleCheckboxChange(item?.id)}
                              />
                            </td>

                            <td>
                              <div className="product_info_cell">
                                <div className="product_img_holder">
                                  <img
                                    src={
                                      process.env.REACT_APP_IMAGE_URL +
                                      item?.Product?.image
                                    }
                                    alt={item?.Product?.name}
                                    className="product_img"
                                  />
                                </div>

                                <div className="product_details">
                                  <div className="bold_text">
                                    {item?.Product?.name}
                                  </div>
                                  <div className="product_details mb-3">
                                    <div className="bold_text">
                                      Product Details
                                    </div>
                                    {item?.Product?.Frame_Type?.name && (
                                      <p className="normal_text">
                                        Frame Type –{" "}
                                        {item?.Product?.Frame_Type?.name}
                                      </p>
                                    )}
                                    {item?.Product?.Colour?.name && (
                                      <p className="normal_text">
                                        Colour – {item?.Product?.Colour?.name}
                                      </p>
                                    )}
                                    {item?.Product?.Material?.name && (
                                      <p className="normal_text">
                                        Material –{" "}
                                        {item?.Product?.Material?.name}
                                      </p>
                                    )}
                                    {item?.Product?.size && (
                                      <p className="normal_text">
                                        Size – {item?.Product?.size}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="price_qty_wrap">
                                <div className="price_cell">
                                  <span className="bold_text current_price">
                                    ₹{item?.Product?.price}
                                  </span>
                                  {getDiscountPercent(
                                    item?.Product?.mrp,
                                    item?.Product?.price,
                                  ) > 0 && (
                                    <>
                                      <span className="mrp_price">
                                        ₹{item?.Product?.mrp}
                                      </span>
                                      <span className="discount_badge">
                                        {getDiscountPercent(
                                          item?.Product?.mrp,
                                          item?.Product?.price,
                                        )}
                                        % off
                                      </span>
                                    </>
                                  )}
                                </div>

                                {/* Quantity stepper — contact lenses only */}
                                {renderQtyStepper(item)}
                              </div>
                            </td>

                            <td className="action_div">
                              <RemoveFuse
                                onRemove={() =>
                                  DeleteCartProduct(item?.id, item?.product_id)
                                }
                              />
                            </td>
                          </tr>

                          {/* ---------- Add Your Lenses row ---------- */}
                          {showAddLens && (
                            <tr className="addon_row">
                              <td className="addon_row_spacer"></td>
                              <td colSpan={3}>{renderAddLensButtons(item)}</td>
                            </tr>
                          )}

                          {/* ---------- Lens row ---------- */}
                          {hasLens && (
                            <tr
                              className={`addon_row ${
                                hasAddon ? "has_addon" : ""
                              }`}
                            >
                              <td className="addon_row_spacer"></td>

                              <td>
                                <div className="product_info_cell">
                                  <div className="product_img_holder">
                                    <img
                                      src={
                                        "/assets/images/lanse/lense_img_1.png"
                                      }
                                      alt="lense"
                                      className="product_img"
                                    />
                                  </div>

                                  <div className="product_details">
                                    <div className="bold_text">
                                      {item?.Prescription?.Lense?.name}
                                    </div>

                                    <div className="product_details mb-3">
                                      <div className="bold_text">Details</div>
                                      <p className="normal_text">
                                        Type –{" "}
                                        {item?.Prescription?.Lense?.LensType
                                          ?.name || "NA"}
                                      </p>
                                      <p className="normal_text">
                                        Brand –{" "}
                                        {item?.Prescription?.Lense?.Brand
                                          ?.name || "NA"}
                                      </p>
                                      <p className="normal_text">
                                        Material –{" "}
                                        {item?.Prescription?.Lense?.Material
                                          ?.name || "NA"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="price_cell">
                                  <span className="bold_text current_price">
                                    ₹{item?.Prescription?.Lense?.price ?? "NA"}
                                  </span>
                                  {getDiscountPercent(
                                    item?.Prescription?.Lense?.mrp,
                                    item?.Prescription?.Lense?.price,
                                  ) > 0 && (
                                    <>
                                      <span className="mrp_price">
                                        ₹{item?.Prescription?.Lense?.mrp}
                                      </span>
                                      <span className="discount_badge">
                                        {getDiscountPercent(
                                          item?.Prescription?.Lense?.mrp,
                                          item?.Prescription?.Lense?.price,
                                        )}
                                        % off
                                      </span>
                                    </>
                                  )}
                                </div>
                              </td>

                              <td className="action_div">
                                <RemoveFuse
                                  onRemove={() =>
                                    DeleteCartLeans(
                                      item?.Prescription?.id,
                                      item?.product_id,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          )}

                          {/* ---------- Add-on row ---------- */}
                          {hasAddon && (
                            <tr className="addon_row">
                              <td className="addon_row_spacer"></td>

                              <td>
                                <div className="product_info_cell">
                                  <div className="product_img_holder">
                                    <img
                                      src={
                                        process.env.REACT_APP_IMAGE_URL +
                                        item?.Prescription?.Addon?.image
                                      }
                                      alt={item?.Product?.name}
                                      className="product_img"
                                    />
                                  </div>

                                  <div className="product_details">
                                    <div className="product_details mb-3">
                                      <div className="bold_text">
                                        Add-On Details
                                      </div>
                                      <p className="normal_text">
                                        Name –{" "}
                                        {item?.Prescription?.Addon?.name ||
                                          "NA"}
                                      </p>
                                      <p className="normal_text">
                                        Price –{" "}
                                        {item?.Prescription?.Addon?.price ||
                                          "NA"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="price_cell">
                                  <span className="bold_text current_price">
                                    ₹{item?.Prescription?.Addon?.price ?? "NA"}
                                  </span>
                                  {getDiscountPercent(
                                    item?.Prescription?.Addon?.mrp,
                                    item?.Prescription?.Addon?.price,
                                  ) > 0 && (
                                    <>
                                      <span className="mrp_price">
                                        ₹{item?.Prescription?.Addon?.mrp}
                                      </span>
                                      <span className="discount_badge">
                                        {getDiscountPercent(
                                          item?.Prescription?.Addon?.mrp,
                                          item?.Prescription?.Addon?.price,
                                        )}
                                        % off
                                      </span>
                                    </>
                                  )}
                                </div>
                              </td>

                              <td className="action_div"></td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <Form>
              <div className="footer_div">
                <h6 style={{ fontSize: "15px", marginBottom: "0px" }}>
                  Best Coupons
                </h6>

                <p
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "12px",
                    marginBottom: "0px",
                  }}
                  onClick={() => setModalShow(true)}
                >
                  View All Coupon <FontAwesomeIcon icon={faAngleRight} />
                </p>
              </div>

              <div className="footer_div">
                <Form.Group className="input_group">
                  <Form.Control
                    type="text"
                    placeholder="Enter your coupon code"
                    {...register("code", { required: "Code is required" })}
                  />
                  {errors?.code && (
                    <sup className="text-danger">{errors?.code?.message}</sup>
                  )}
                </Form.Group>
                {CouponData ? (
                  <div className="btn_holder">
                    <Red_Outline_Btn
                      type="button"
                      btnText={"Remove"}
                      onClick={handleCouponReset}
                    />
                  </div>
                ) : (
                  <div className="btn_holder">
                    <Gray_Outline_Button
                      type="button"
                      btnText={"Apply"}
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                )}
              </div>
            </Form>
          </div>
        )}
      </div>

      {/* Lens button tooltip (inline styles - no CSS file needed) */}
      {tooltip && (
        <div
          role="tooltip"
          style={{
            position: "fixed",
            left: tooltip.left,
            top: tooltip.top,
            transform: tooltip.below ? "none" : "translateY(-100%)",
            width: "max-content",
            maxWidth: tooltip.maxW,
            padding: "8px 10px",
            background: "#1c2a33",
            color: "#fff",
            fontSize: 12,
            fontWeight: 400,
            lineHeight: 1.4,
            textAlign: "left",
            borderRadius: 6,
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            pointerEvents: "none",
            zIndex: 2147483000,
          }}
        >
          {tooltip.text}
        </div>
      )}

      <Success_Modal
        show={showModal}
        successText="Coupon applied successfully"
        onHide={() => setShowModal(false)}
      />

      <View_All_Coupon_Code
        onApply={(code) => {
          setValue("code", code); // set coupon in input
          handleSubmit(onSubmit)();
          setModalShow(false); // hit apply API
        }}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      {/* Lens flow: Lens_Details_Modal -> AddOn_Details_Modal -> Lense_prescription_modal */}
      <Lens_Details_Modal
        product={lensTarget?.Product}
        variant={{ id: lensTarget?.variant_id }}
        product_id={lensTarget?.product_id}
        lensTypeId={lensTypeId}
        lensTypeName={getLensTypeName(lensTypeId)}
        onLensAdded={handleCartLensAdded}
        show={showLensDetails}
        onHide={() => setShowLensDetails(false)}
      />
    </section>
  );
};

export default Product_Info;